import KendoEditor from '../KendoEditor'
import KendoEditorTool from '../KendoEditorTool'

let KendoEditorInstaller = class {
    static install(Vue) {
        Vue.component(KendoEditor.name, KendoEditor)
        Vue.component(KendoEditorTool.name, KendoEditorTool)
    }
}

export default KendoEditorInstaller

// Automatic installation if Vue has been added to the global scope.
if (typeof window !== 'undefined' && window.Vue && window.Vue.use) {
    window.Vue.use(KendoEditorInstaller)
}


// WEBPACK FOOTER //
// ./packages/kendo-editor-vue-wrapper/src/kendo-editor-installer/index.js